function createSymbol(name) {
  return `CHECKS/${name}`;
}

export const FETCH_DATA = createSymbol('FETCH_DATA');

export const FETCH_CHECKS = createSymbol('FETCH_CHECKS');
export const FETCH_NEXT_CHECKS = createSymbol('FETCH_NEXT_CHECKS');

export const FETCH_CHECKS_SUCCESS = createSymbol('FETCH_CHECKS_SUCCESS');
export const FETCH_CHECKS_FAILURE = createSymbol('FETCH_CHECKS_FAILURE');

export const UPDATE_CHECK = createSymbol('UPDATE_CHECK');
export const DELETE_CHECK = createSymbol('DELETE_CHECK');

export const FETCH_FILTERS = createSymbol('FETCH_FILTERS');
export const FETCH_FILTERS_SUCCESS = createSymbol('FETCH_FILTERS_SUCCESS');
export const FETCH_FILTERS_FAILURE = createSymbol('FETCH_FILTERS_FAILURE');

export const START_RECORD_PROCESS = createSymbol('START_RECORD_PROCESS');
export const ERROR_RECORD_PROCESS = createSymbol('ERROR_RECORD_PROCESS');
export const FINISH_RECORD_PROCESS = createSymbol('FINISH_RECORD_PROCESS');
export const REQUEST_UPDATE_RECORD = createSymbol('REQUEST_UPDATE_RECORD');
export const REQUEST_DELETE_RECORD = createSymbol('REQUEST_DELETE_RECORD');

export const FETCH_DICTIONARIES_CATEGORIES = createSymbol('FETCH_DICTIONARIES_CATEGORIES');
export const FETCH_DICTIONARIES_CATEGORIES_SUCCESS = createSymbol(
  'FETCH_DICTIONARIES_CATEGORIES_SUCCESS',
);

export const FETCH_ONLY_CATEGORIES = createSymbol('FETCH_ONLY_CATEGORIES');
